import request from '@/utils/request'

// 广告弹窗 / 通知配置（app_notice）

export interface AppNotice {
  id?: number
  title: string
  content?: string
  imageUrl?: string
  linkUrl?: string
  status?: number
  storeId?: number | null
  sort?: number
}

// 列表
export const getNoticeList = (params: { storeId?: number; status?: number }) => {
  return request({
    url: '/notice/list',
    method: 'get',
    params
  })
}

// 新增
export const createNotice = (data: AppNotice) => {
  return request({
    url: '/notice',
    method: 'post',
    data
  })
}

// 修改
export const updateNotice = (data: AppNotice) => {
  return request({
    url: '/notice',
    method: 'put',
    data
  })
}

// 删除
export const deleteNotice = (id: number) => {
  return request({
    url: `/notice/${id}`,
    method: 'delete'
  })
}

export const noticeMoveSort = (params: { id: number | string; direction: 'up' | 'down' }) => {
  return request({
    url: `/notice/sort/${params.direction}`,
    method: 'post',
    params: { id: params.id }
  })
}

export const noticeSetSort = (params: { id: number | string; sort: number }) => {
  return request({
    url: `/notice/sort`,
    method: 'post',
    params: { id: params.id, sort: params.sort }
  })
}
